import { Skeleton } from '@/design-system/ui/Skeleton';

/**
 * Esqueleto enquanto a página carrega (fallback do `Suspense` das rotas). O formato
 * acompanha o layout: indicadores e listas no dashboard, barra de filtros e linhas nas
 * listas.
 */
export default function PageSkeleton({ variant = 'list' }: { variant?: 'dashboard' | 'list' }) {
  return (
    <div role="status" aria-label="Carregando" className="flex flex-col gap-4">
      {variant === 'dashboard' ? (
        <>
          <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-3.5">
            {Array.from({ length: 4 }, (_, i) => (
              <div
                key={i}
                className="flex flex-col gap-3 rounded-card border border-line-card bg-white p-4.5"
              >
                <Skeleton className="h-3 w-1/2" />
                <Skeleton className="h-6.5 w-1/3 rounded-control-sm" />
                <Skeleton className="h-2.5 w-2/3" />
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-4 rounded-card border border-line-card bg-white p-4.5">
            {Array.from({ length: 4 }, (_, i) => (
              <div key={i} className="flex items-center gap-3.5">
                <Skeleton className="size-12 rounded-control" />
                <div className="flex flex-1 flex-col gap-2">
                  <Skeleton className="h-3 w-2/5" />
                  <Skeleton className="h-2.5 w-3/4" />
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="flex gap-2.5">
            <Skeleton className="h-9.5 w-60 max-w-1/2 rounded-control" />
            <Skeleton className="h-9.5 w-30 rounded-control" />
          </div>
          <div className="overflow-hidden rounded-card border border-line-card bg-white">
            {Array.from({ length: 6 }, (_, i) => (
              <div key={i} className="flex items-center gap-3.5 border-b border-line-divider px-4.5 py-3.5">
                <Skeleton className="size-9 rounded-pill" />
                <div className="flex flex-1 flex-col gap-2">
                  <Skeleton className="h-3 w-1/3" />
                  <Skeleton className="h-2.5 w-3/5" />
                </div>
                <Skeleton className="h-6 w-20 rounded-pill" />
              </div>
            ))}
          </div>
        </>
      )}
      <span className="sr-only">Carregando conteúdo…</span>
    </div>
  );
}
